import { render, staticRenderFns } from "./RacerRulesAndFaqs.vue?vue&type=template&id=a33c98f0"
import script from "./RacerRulesAndFaqs.vue?vue&type=script&lang=js"
export * from "./RacerRulesAndFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports